import * as React from 'react';
import './steps-description-step.styles.less';

const StepsDescriptionStep: React.FC<IStepsDescriptionStep> = ({ index, text, title }) => (
    <div className="sitegen-steps-description-step">
        <div className="sitegen-steps-description-step__index">
            { index }
        </div>
        <div>
            <div className="sitegen-steps-description-step__title">
                { title }
            </div>
            <div className="sitegen-steps-description-step__text">
                { text }
            </div>
        </div>
    </div>
);

export interface IStepsDescriptionStep {
    index: number;
    text: string;
    title: string;
}

export default StepsDescriptionStep;
